import React, { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { customToast } from "../../components/Toast"
import Send from "../../core/communication"
import { getIds } from "../../core/utils/getIds"
import { toRemoveDoubleQuoteArr, useDWOptions } from "../../core/utils/hooks/useDwOptions"
import DashboardScreen from "../../screen/DashboardScreen"
import { formattedProjects } from "../../components/Subheader"
import moment from "moment"
import { useProjects, useScope } from "../SelectProjectCompanyContainer"
import { useSelector } from "react-redux"
import { removeDuplicatedArray } from "../../core/utils/manipulateArrays"
import { exportSelectedForms, exportUsersProject, exportUsersSupplier, exportUsersTraining } from "../../core/utils/exports"
import { VALE_USERS_EMAIL } from "../../core/vale/users"
import { useUsers, useUsersProject } from "../../core/utils/hooks/useUsers"

export const formatData = (data) => {
  return data.map((item) => ({
    ...item,
    Mes: moment(item.Data?.value, "YYYY-MM-DD").format("MMMM"),
    Ano: moment(item.Data?.value, "YYYY-MM-DD").format("YYYY"),
  }))
}

const filterType = [
  {
    value: "company",
    label: "Empresa",
  },
  {
    value: "organization",
    label: "Organização",
  },
  {
    value: "project",
    label: "Projetos",
  },
]

const DashboardContainer = () => {
  const user = useSelector((state) => state.app?.user?.user)
  const { users } = useUsers()
  const { projects } = useProjects()
  const { scope, scopeType } = useScope()
  const [values, setValues ] = useState({})
  const [dw, reload, loadingDw] = useDWOptions(values)
  const { organizations } = useSelector((state) => state.app)
  const [data, setData] = useState([])
  const [events, setEvents] = useState([])
  const [resetFields, setResetFields] = useState(false)
  const [type, setType] = useState(1)
  const [loading, setLoading] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [downloadModalIsOpen, setDownloadModalIsOpen] = useState(false)
  const {exportUsers} = exportUsersProject(users, 'users_engagement_')
  const usersSupplier = exportUsersSupplier(scope)
  const {usersProject} = useUsersProject()
  const [desc, setDesc] = useState()
  const usersTraining = exportUsersTraining(usersProject, desc)
  const {exportForms, exportFormsLoading } = exportSelectedForms()
  const [valuesDownloads, setValuesDownloads] = useState({});

  const { control, resetField } = useForm({
    mode: "onChange",
  })

  const linkDesc = (e) => {
    setDesc(e.target.value)
  }

  const onChange = (field) => {
    return (value) => {
      if(field === 'filterType') {
        setValues((values) => ({ ...values, [field]: value, "scope": null }));
        return;
      }

      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const onChangeValues = (field) => {
    return (value) => {
      setValuesDownloads((valuesDownloads) => ({ ...valuesDownloads, [field]: value }))
    }
  }

  const onSearch = async () => {
    let extraProps = "";
    let selectedScopeType = values?.filterType?.value;

    if(!values?.scope || !values?.scope.length) {
      customToast(
        `Você deve selecionar ao menos um(a) ${filterType.find(row => row?.value === selectedScopeType)?.label}`,
        'error'
      );
      return;
    }

    if (values.questions && values.questions.length > 0) {
      extraProps += `&questions=${getIds(values.questions)}`
    }

    if (values.farmers && values.farmers.length > 0) {
      extraProps += `&farmers=${getIds(values.farmers)}`
    }

    if (values.forms && values.forms.length > 0) {
      extraProps += `&forms=${getIds(values.forms)}`
    }
    
    let newScope = toRemoveDoubleQuoteArr(values?.scope);

    setLoading(true)
    const dw = Send.get("/dw/data", `projects=${newScope}&scopeType=${selectedScopeType}${extraProps}`).then(
      (response) => {
        return formatData(response)
      },
    )

    await Promise.all([dw])
      .then(([dw]) => {
        if (dw.length) {
          setData(dw)
          onCloseModal()
        } else {
          setData([])
          customToast("Não há dados para gerar a tabela!", "warning")
        }
      })
      .catch((e) => {
        setData([])
      })
    setLoading(false)
  }

  const onCloseModal = () => {
    resetField("projects")
    setModalIsOpen(false)
  }

  const onCloseDownloadModal = () => {
    setDownloadModalIsOpen(false)
  }

  useEffect(() => {
    setPreValues(scope, setValues, filterType.find(row => row.value == scopeType))
  }, [scope, scopeType])


  useEffect(() => {
    if(!values?.scope?.length || !filterType){
      setData([])
    }
  }, [values?.scope, filterType])


  return (
    <DashboardScreen
      {...{
        events,
        loading,
        loadingDw,
        type,
        setType,
        data,
        onSearch,
        onChange,
        values,
        reload,
        dw: {
          ...dw,
          forms: removeDuplicatedArray(dw?.forms?.flat(), "label"),
          questions: removeDuplicatedArray(dw?.questions?.flat(), "label"),
          projects: formattedProjects(projects) || [],
          filterType,
          organizations: formatDataOrganizations(organizations),
          companies: formatDataOrganizations(organizations, "companies"),
        },
        control,
        resetFields,
        setModalIsOpen,
        setDownloadModalIsOpen,
        onCloseModal,
        onCloseDownloadModal,
        modalIsOpen,
        downloadModalIsOpen,
        onChangeValues,
        value: desc,
        exportForms,
        exportFormsLoading,
        usersByProject: exportUsers,
        hideDownloadOptions: VALE_USERS_EMAIL.includes(user?.email),
        usersTraining,
        onChangeDownload: linkDesc,
        usersSupplier,
        valuesDownloads,
        setValuesDownloads,
      }}
    />
  )
}

export default DashboardContainer

export const formatDataOrganizations = (data = [], keyFilter = "organizations") => {
  if (!data || !data.length) return []

  let uniqueIds = []

  if (keyFilter === "companies") {
    const companies = data.flatMap((item) => item?.companies)
    uniqueIds = [...new Set(companies.map((item) => item.id))]

    return uniqueIds.map((id) => ({
      value: id,
      label: companies.find((item) => item.id === id)?.name,
    }))
  } else {
    uniqueIds = [...new Set(data.filter((item) => item.name !== "Outras").map((item) => item.id))]

    return uniqueIds.map((id) => ({
      value: id,
      label: data.find((item) => item.id === id)?.name,
    }))
  }
}

const setPreValues = (scope, setValues, currentFilterType) => {
  setValues({
    filterType: currentFilterType,
    scope: [{
      value: scope?.id,
      label: currentFilterType?.value === 'project' ? scope?.description : scope?.name
    }]
  })
}
